var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoliceLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1065)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5 69.25C30.2604 67.4271 24.2833 63.2729 19.5688 56.7875C14.8542 50.3021 12.4979 43.1021 12.5 35.1875V16.125L37.5 6.75L62.5 16.125V35.1875C62.5 43.1042 60.1438 50.3052 55.4313 56.7906C50.7188 63.276 44.7417 67.4292 37.5 69.25ZM31.25 50.5H43.75C44.6354 50.5 45.3781 50.2 45.9781 49.6C46.5781 49 46.8771 48.2583 46.875 47.375V38C46.875 37.1146 46.575 36.3729 45.975 35.775C45.375 35.1771 44.6333 34.8771 43.75 34.875V31.75C43.75 30.0312 43.1385 28.5604 41.9156 27.3375C40.6927 26.1146 39.2208 25.5021 37.5 25.5C35.7792 25.4979 34.3083 26.1104 33.0875 27.3375C31.8667 28.5646 31.2542 30.0354 31.25 31.75V34.875C30.3646 34.875 29.6229 35.175 29.025 35.775C28.4271 36.375 28.1271 37.1167 28.125 38V47.375C28.125 48.2604 28.425 49.0031 29.025 49.6031C29.625 50.2031 30.3667 50.5021 31.25 50.5ZM34.375 34.875V31.75C34.375 30.8646 34.675 30.1229 35.275 29.525C35.875 28.9271 36.6167 28.6271 37.5 28.625C38.3833 28.6229 39.126 28.9229 39.7281 29.525C40.3302 30.1271 40.6292 30.8687 40.625 31.75V34.875H34.375Z",
    fill: "url(#paint0_linear_1_1065)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1065",
    x: 8.5,
    y: 6.75,
    width: 58,
    height: 70.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1065",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1065",
    x1: 37.5,
    y1: 6.75,
    x2: 37.5,
    y2: 69.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20AC95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018563"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliceLock);
export default __webpack_public_path__ + "static/media/PoliceLock.95e89cf376231bc24a6b14171cbe55ea.svg";
export { ForwardRef as ReactComponent };